<template>
  <div>
        <van-popup v-model="showTrayInfo" position="bottom" class="trayInfo-pop" >
      <div class="title-pop">扫码结果</div>
    <div class="result-info">
      <div class="icon-bg">
        !
      </div>
      <div class="result-info-text">
        <span v-if="trayInfo.typeName">{{trayInfo.typeName}}</span>
        <div v-else>
          <span v-if="trayCodeType==='1'">中箱码</span>
          <span v-if="trayCodeType==='9'">托盘码</span>
          <span v-if="trayCodeType!=='9'&&trayCodeType!=='1'">托盘码/中箱码</span>
        </div>
      </div>
      <div class="result-info-text2">
        仅限信息查询
      </div>
    </div>
    <div class="info">
      <div class="info-item">
        <div class="title">产品名称</div>
        <div class="text">{{trayInfo.productName}}</div>
      </div>
      <div class="info-item">
        <div class="title">产品料号</div>
        <div class="text">{{trayInfo.partNo}}</div>
      </div>
      <div class="info-item" v-if="trayInfo.partQty">
        <div class="title">数量</div>
        <div class="text">{{trayInfo.partQty}}</div>
      </div>
      <div class="info-item" v-if="trayInfo.subTrayPartQty">
        <div class="title">下级数量</div>
        <div class="text">{{trayInfo.subTrayPartQty}}</div>
      </div>
      <!-- <div class="info-item">
        <div class="title">工厂</div>
        <div class="text">{{trayInfo.factoryInfo}}</div>
      </div> -->
      <div class="info-item">
        <div class="title">经销商</div>
        <div class="text">{{trayInfo.wholesalerInfo}}</div>
      </div>
    </div>

    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    trayInfo: {
      type: Object,
      required: true
    },
    showTrayInfo: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      trayCodeType: '',
      isShow: false
    }
  },
  watch: {
    'trayInfo' () {
      this.trayCodeType = this.trayInfo.trayCode ? this.trayInfo.trayCode.split('_')[1] : ''
    }
  },
  created () {
    this.isShow = this.showTrayInfo
    if (this.trayInfo !== '') {
      this.trayCodeType = this.trayInfo.trayCode ? this.trayInfo.trayCode.split('_')[1] : ''
    }
  }
}
</script>

<style lang="less" scoped>
.result-info{
  text-align: center;
  padding: 20px 0 20px 0;
  img{
    width: 80px;
  }
  .result-info-text{
    padding: 20px 0 5px 0;
    font-size: 16px;
  }
  .result-info-text2{
    border-radius: 5px;
    margin-top: 5px;
    display: inline-block;
    width: 110px;
    color: rgb(26, 164, 245);
    font-size: 13px;
    padding: 4px 0px;
    background-color: rgb(234, 242, 245);
  }
}
.info-item{
  margin: 15px 25px;
  display: flex;
  justify-content: space-between;
  .title{
    color: gray;
    min-width: 95px;
  }
}
.icon-bg{
  display: inline-block;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: #117281;
  font-size: 60px;
  color: white;
}
.trayInfo-pop{
  height: 50%;
  min-height: 400px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}
.title-pop{
  height: 30px;
  width: 100%;
  line-height: 30px;
  color: white;
  text-align: center;
  background-color: #117281;
}
</style>
